import Loadable from 'react-loadable';
import { LoadingIndicator } from 'web-ui-kit/loading';

export default Loadable({
  loader: () => import('./ResetPasswordRequest' /* webpackChunkName: "ResetPasswordRequest" */),
  loading: LoadingIndicator
});
